module.exports = __webpack_public_path__ + "static/steve_heim-4ea10f5bc5ce7a78e2f75869bbe21b58.jpg";